import { add, compare, fromNumber, toNumber } from './BigNumber.js';

// The genre-standard geometric cost curve: the nth copy of a unit costs
// base * growth^n. Extracted here so the summation is unit-testable and shared
// between the buy handlers and the affordability UI.
export const UNIT_GROWTH = 1.15;

// Big-number sum of `amount` consecutive copies starting from `owned`.
export function geometricCostSum(base, owned, amount, growth = UNIT_GROWTH) {
  let total = fromNumber(0);
  for (let index = 0; index < amount; index += 1) {
    total = add(total, fromNumber(base * (growth ** (owned + index))));
  }
  return total;
}

// Largest whole quantity of a unit affordable with `credits` on hand.
// Closed form of the geometric series, clamped and floored so the caller can
// offer a "book the most you can" action without a loop.
export function maxAffordable(base, owned, credits, growth = UNIT_GROWTH) {
  const budget = toNumber(credits);
  const nextCost = base * (growth ** owned);
  if (!Number.isFinite(budget) || budget < nextCost) return 0;
  // budget >= base*growth^owned * (growth^n - 1) / (growth - 1)
  const ratio = (budget * (growth - 1)) / (base * (growth ** owned)) + 1;
  return Math.max(0, Math.floor(Math.log(ratio) / Math.log(growth)));
}

// Convenience guard used by callers that already hold a big-number cost.
export function canAfford(credits, cost) {
  return compare(credits, cost) >= 0;
}
